<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Création de l'ordonnance à imprimer </div>
        <div class="modal-body">
            <form [formGroup]="ordonnanceForm" *ngIf="ordonnanceForm" class="ordonnance-card-content">
                <frg-form-input label="Titre de la consultation" class="input-edit-mode" id="titre" type="text"
                    [formGroup]="ordonnanceForm" [control]="ordonnanceForm.get('titre')">
                </frg-form-input>
                <div class="col-container">
                    <div class="col col-1">
                        <div class="buttons-froala">

                            <div class="icon-button" title="Ajout de texte en rapport avec ALD" (mousedown)="addAld()">
                                ALD
                            </div>
                            <div class="last-button">
                                <div class="icon-button fullscreen" title="Agrandir la zone de saisie"
                                    (mousedown)="toggleFullscreen()" *ngIf="!isFullscreen"></div>
                                <div class="icon-button minscreen" title="Rétrécir la zone de saisie"
                                    (mousedown)="toggleFullscreen()" *ngIf="isFullscreen"></div>
                            </div>
                        </div>

                        <froala-editor class="froala-editor" [froalaEditor]="editorOptions" [(froalaModel)]="editorContent"  (froalaInit)="initialize($event)"
                        cdkDropList (cdkDropListDropped)="dropped($event)" id="froalaDrop" #froalaDrop cdkDropListConnectedTo="table2"
                        placeholder="Ajouter du texte ici..." ></froala-editor>
                        
                        <div class="checks-container" [ngClass]="{'minimize-checks': isFullscreen}">
                            Options d'en-têtes et d'impression
                            <div class="check-line">
                                <frg-form-input label="Entête vide" id="isEnteteVide" type="checkbox"
                                    [formGroup]="ordonnanceForm" [control]="ordonnanceForm.get('isEnteteVide')"
                                    [isCheckLabelAlign]="true" class="input">
                                </frg-form-input>
                                <frg-form-input label="Pied de page vide" id="isPiedVide" type="checkbox"
                                    [formGroup]="ordonnanceForm" [control]="ordonnanceForm.get('isPiedVide')"
                                    [isCheckLabelAlign]="true" class="input">
                                </frg-form-input>
                                <frg-form-input label="Retenir l'envoi au DMP" id="retenueEnvoiDmp" type="checkbox"
                                    [formGroup]="ordonnanceForm" [control]="ordonnanceForm.get('retenueEnvoiDmp')"
                                    [isCheckLabelAlign]="true" class="input">
                                </frg-form-input>
                            </div>
                        </div>
                    </div>
                    <div class="col col-2">
                        <div class="buttons-table">
                            <div [ngClass]="{'active': isTag === true}" class="icon-button tag" title="Tags"
                                (mousedown)="changeTable('tag')"></div>
                            <div [ngClass]="{'active': isGlossaire === true}" class="icon-button glossaire"
                                title="Glossaire" (mousedown)="changeTable('glossaire')"></div>
                            <div [ngClass]="{'active': isPenseBete === true}" class="icon-button pense-bete"
                                title="Pense-bête" (mousedown)="changeTable('penseBete')"></div>
                            <div [ngClass]="{'active': isMaquette === true}" class="icon-button maquette"
                                title="Maquettes" (mousedown)="changeTable('maquette')"></div>
                            <div [ngClass]="{'active': isCriteres === true}" class="icon-button critere"
                                title="Criteres" (mousedown)="changeTable('critere')">
                            </div>
                            <div [ngClass]="{'active': isDossierPatient === true}"
                                class="icon-button element-dossier-patient" title="Dossier patient"
                                (mousedown)="changeTable('dossierPatient')"></div>
                            <div [ngClass]="{'active': isCourrierPerso === true}"
                                class="icon-button liste-courrier-type" title="Courriers personnalisés"
                                (mousedown)="changeTable('courrierPerso')"></div>
                            <div [ngClass]="{'active': isMedicamentPerso === true}"
                                class="icon-button medicaments-saisie-libre" title="Médicaments saisie libre"
                                (mousedown)="changeTable('medicamentPerso')"></div>


                        </div>
                        <frg-search-input #searchInput (search)="filterAutoreplaceList($event)"></frg-search-input>
                        <frg-table #table2 [keysBody]="autoReplaceBodyTable" [keysColumn]="autoReplaceColumnTable"
                            class="table" [dragDrop]="true" idDropTable="table2" idConnectedTable="froalaDrop">
                        </frg-table>
                        <div class="button-wrapper">
                            <frg-button class="ordo-button" (activated)="previewImpression()"
                                [backgroundColor]="'var(--primary)'">Imprimer
                            </frg-button>
                            <frg-button class="ordo-button" [type]="'reset'" (activated)="closeEditOrdonnanceModal()"
                                [backgroundColor]="'var(--darkest-primary)'">Fermer
                            </frg-button>
                            <frg-button class="ordo-button" (activated)="createCourrier()"
                                [backgroundColor]="'var(--darkest-primary)'">Enregistrer dans Courriers
                            </frg-button>
                        </div>
                        <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                            {{errorMessage}}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-background"></div>